import {
  MinusCircleOutlined,
  PlusCircleOutlined,
  SearchOutlined,
  SwapOutlined,
} from "@ant-design/icons";
import { Col, Divider, Form, Modal, Row } from "antd";
import { useEffect, useState } from "react";
import type { StoreEntity, ZoneEntity } from "../../../entities/StoreEntity";
import { getCustomers, getZones } from "../../../datasource/CustomerDatasource";
import { getShopGroup } from "../../../datasource/ShopGroupDatasoure";
import { useEffectOnce } from "react-use";
import _ from "lodash";
import { color, image } from "../../../resource";
import { FlexCol } from "../../../components/Container/Container";
import Text from "../../../components/Text/Text";
import Select from "../../../components/Select/Select";
import Input from "../../../components/Input/Input";
import Button from "../../../components/Button/Button";

export const ModalSelectStore = ({
  callBackShop,
  showModalShop,
  onClose,
  currentSelectShop,
  company,
  limitSelected,
  customerType,
  replaceTitle,
  replaceSaveButtonTitle,
  hideCurrect,
  excludeCusCompanyId,
  isFilterShop = true,
}: {
  callBackShop: (item: StoreEntity[]) => void;
  showModalShop: boolean;
  onClose: () => void;
  currentSelectShop: StoreEntity[];
  company: string;
  limitSelected?: number | 0;
  customerType?: "DL" | "SD";
  replaceTitle?: string | React.ReactNode;
  replaceSaveButtonTitle?: string;
  hideCurrect?: boolean;
  excludeCusCompanyId: number[];
  isFilterShop?: boolean;
}) => {
  const [zoneList, setZoneList] = useState<ZoneEntity[]>([]);
  const [storeList, setStoreList] = useState<StoreEntity[]>([]);
  const [leftStoreList, setLeftStoreList] = useState<StoreEntity[]>([]);
  const [storeSelected, setStoreSelected] = useState<StoreEntity[]>([]);
  const [rightStoreList, setRightStoreList] = useState<StoreEntity[]>([]);
  const [shopGroup, setShopGroup] = useState<{ count: number; data: any[] }>({
    count: 0,
    data: [],
  });
  const [searchZone1, setSearchZone1] = useState("");
  const [searchShopGroup1, setSearchShopGroup1] = useState("");
  const [searchShopGroup2, setSearchShopGroup2] = useState("");
  const [searchKeyWord1, setSearchKeyWord1] = useState("");
  const [searchZone2, setSearchZone2] = useState("");
  const [searchKeyWord2, setSearchKeyWord2] = useState("");
  const [isLeftCheckDis, setIsLeftCheckDis] = useState<boolean>(
    currentSelectShop.length === (limitSelected || 10000 || currentSelectShop.length),
  );
  const [isLeftAllCheckDis, setIsLeftAllCheckDis] = useState<boolean>(
    limitSelected !== undefined ? true : false,
  );
  const [initialSelectedShop, setInitialSelectedShop] = useState<StoreEntity[]>([]);

  useEffect(() => {
    if (showModalShop) {
      setInitialSelectedShop(currentSelectShop);
    }
  }, [showModalShop]);

  const fetchStore = async () => {
    const getShop = await getCustomers({
      company,
      customerType: customerType || "DL",
    });
    let excludedStoreList = [];
    if (currentSelectShop.length > 0) {
      if (isFilterShop) {
        currentSelectShop = currentSelectShop.map((item) => ({ ...item, isChecked: false }));
        const dataWithIschecked = getShop.data
          .map((p: any) => {
            const matching = currentSelectShop.find(
              (i) => `${i.customerCompanyId}` === `${p.customerCompanyId}`,
            );
            if (matching) {
              return { ...matching, isChecked: true };
            }
            return {
              ...p,
              isChecked: p.isChecked || false,
            };
          })
          .filter((x: any) => !x.isChecked);

        const dataToBeUsed = hideCurrect
          ? dataWithIschecked.filter(
              (d) => !currentSelectShop.find((dl) => d.customerCompanyId === dl.customerCompanyId),
            )
          : dataWithIschecked;
        excludedStoreList = dataToBeUsed.filter(
          (store) => !String(excludeCusCompanyId).includes(store.customerCompanyId),
        );
      } else {
        excludedStoreList = getShop.data.map((p: any) => {
          const matching = currentSelectShop.find(
            (i) => `${i.customerCompanyId}` === `${p.customerCompanyId}`,
          );
          if (matching) {
            return { ...matching, isChecked: true };
          } else {
            return {
              ...p,
              isChecked: false,
            };
          }
        });
        setRightStoreList(excludedStoreList);
      }
    } else {
      excludedStoreList = getShop.data.map((p: any) => ({ ...p, isChecked: false }));
    }
    setLeftStoreList(excludedStoreList);
    setStoreList(excludedStoreList);
  };
  const fetchZone = async () => {
    const getZone = await getZones(company);
    setZoneList(getZone);
  };
  const fetchShopGroupList = async () => {
    await getShopGroup({
      company,
      take: 0,
      page: 0,
    }).then((res) => {
      setShopGroup({ count: res.responseData.count, data: res.responseData.data });
    });
  };

  useEffectOnce(() => {
    fetchZone();
    fetchShopGroupList();
  });

  useEffect(() => {
    fetchStore();
  }, [customerType]);

  useEffect(() => {
    setStoreList((prevList) =>
      prevList.map((store) =>
        initialSelectedShop.some(
          (selected) => selected.customerCompanyId === store.customerCompanyId,
        )
          ? { ...store, isChecked: true }
          : { ...store, isChecked: false },
      ),
    );
    setStoreSelected(initialSelectedShop.map((item) => ({ ...item, isChecked: true })));
    //setRightStoreList(initialSelectedShop.map((item) => ({ ...item, isChecked: true })));
  }, [initialSelectedShop]);

  const handleSearchShopGroup = (e: any, section: number) => {
    const shop = e;
    const db = section === 1 ? storeList : storeSelected;
    const dbkeyword = section === 1 ? searchKeyWord1 : searchKeyWord2;
    const dbZone = section === 1 ? searchZone1 : searchZone2;
    const find = db.filter((x: any) => {
      const searchShop = !shop || x.customerGroupName === shop;
      const searchKeyword = !dbkeyword || x.customerGroupName === dbkeyword;
      const searchZone = !dbZone || x.zone?.includes(dbZone);
      return searchShop && searchKeyword && searchZone;
    });
    if (section === 1) {
      setSearchShopGroup1(shop);
      setLeftStoreList(find);
    } else {
      setSearchShopGroup2(shop);
      setRightStoreList(find);
    }
  };
  const handleSearchZone = (e: any, section: number) => {
    const zone = e;
    const db = section === 1 ? storeList : storeSelected;
    const dbkeyword = section === 1 ? searchKeyWord1 : searchKeyWord2;
    const dbshopGroup = section === 1 ? searchShopGroup1 : searchShopGroup2;
    const find = db.filter((x: any) => {
      const searchZone = !zone || x.zone?.includes(zone);
      const searchKeyword =
        !dbkeyword ||
        x.customerName?.includes(dbkeyword) ||
        x.customerNo?.includes(dbkeyword.toUpperCase());
      const searchShop = !dbshopGroup || x.customerGroupName === dbshopGroup;
      return searchZone && searchKeyword && searchShop;
    });
    if (section === 1) {
      setSearchZone1(zone);
      setLeftStoreList(find);
    } else {
      setSearchZone2(zone);
      setRightStoreList(find);
    }
  };
  const handleSearchKeyword = (e: any, section: number) => {
    const keywork = e.target.value;
    const db = section === 1 ? storeList : storeSelected;
    const dbzone = section === 1 ? searchZone1 : searchZone2;
    const dbshopGroup = section === 1 ? searchShopGroup1 : searchShopGroup2;
    const find = db.filter((x: any) => {
      const searchZone = !dbzone || x.zone?.includes(dbzone);
      const searchKeyword =
        !keywork ||
        x.customerName?.includes(keywork) ||
        x.customerNo?.includes(keywork.toUpperCase());
      const searchShop = !dbshopGroup || x.customerGroupName === dbshopGroup;
      return searchZone && searchKeyword && searchShop;
    });

    if (section === 1) {
      setSearchKeyWord1(keywork);
      setLeftStoreList(find);
    } else {
      setSearchKeyWord2(keywork);
      setRightStoreList(find);
    }
  };

  const storeLeft = () => {
    const handleSelectStore = (shop: StoreEntity) => {
      const d: StoreEntity[] = storeList.map((item) =>
        _.set(
          item,
          "isChecked",
          item.customerCompanyId === shop.customerCompanyId ? true : item.isChecked,
        ),
      );
      setIsLeftCheckDis(
        d.filter((x) => x.isChecked).length >= (limitSelected || 10000) - currentSelectShop.length,
      );
      setStoreSelected(d.filter((x) => x.isChecked));
      setRightStoreList(
        d.filter((x: any) => {
          const checked = x.isChecked;
          const searchZone = !searchZone2 || x.zone?.includes(searchZone2);
          const searchShop = !searchShopGroup2 || x.customerGroupName === searchShopGroup2;
          const searchKeyword =
            !searchKeyWord2 ||
            x.customerName?.includes(searchKeyWord2) ||
            x.customerNo?.includes(searchKeyWord2.toUpperCase());
          return searchZone && searchKeyword && searchShop && checked;
        }),
      );
      setStoreList(d);
      setLeftStoreList(
        d.filter((x: any) => {
          const searchZone = !searchZone1 || x.zone?.includes(searchZone1);
          const searchShop = !searchShopGroup1 || x.customerGroupName === searchShopGroup1;
          const searchKeyword =
            !searchKeyWord1 ||
            x.customerName?.includes(searchKeyWord1) ||
            x.customerNo?.includes(searchKeyWord1.toUpperCase());
          return searchZone && searchKeyword && searchShop;
        }),
      );
    };
    const handleSelectAllStore = () => {
      let d: StoreEntity[] = [];
      if (searchZone1 || searchKeyWord1 || searchShopGroup1) {
        const mapData = storeList.filter((x: any) => {
          const searchZone = !searchZone1 || x.zone?.includes(searchZone1);
          const searchShop = !searchShopGroup1 || x.customerGroupName === searchShopGroup1;
          const searchKeyword =
            !searchKeyWord1 ||
            x.customerName?.includes(searchKeyWord1) ||
            x.customerNo?.includes(searchKeyWord1.toUpperCase());
          return searchZone && searchKeyword && searchShop;
        });
        d = storeList.map((el: any) => {
          const matching = mapData.find((i) => i.customerCompanyId === el.customerCompanyId);
          if (matching) {
            return { ...matching, isChecked: true };
          }
          return {
            ...el,
            isChecked: el.isChecked,
          };
        });
      } else {
        d = storeList.map((p: any) => ({ ...p, isChecked: true }));
      }
      setStoreSelected(d.filter((x) => x.isChecked));
      setRightStoreList(
        d.filter((x: any) => {
          const checked = x.isChecked;
          const searchZone = !searchZone2 || x.zone?.includes(searchZone2);
          const searchShop = !searchShopGroup2 || x.customerGroupName === searchShopGroup2;
          const searchKeyword =
            !searchKeyWord2 ||
            x.customerName?.includes(searchKeyWord2) ||
            x.customerNo?.includes(searchKeyWord2.toUpperCase());
          return searchZone && searchKeyword && searchShop && checked;
        }),
      );
      setStoreList(d);
      setLeftStoreList(
        d.filter((x: any) => {
          const searchZone = !searchZone1 || x.zone?.includes(searchZone1);
          const searchShop = !searchShopGroup1 || x.customerGroupName === searchShopGroup1;
          const searchKeyword =
            !searchKeyWord1 ||
            x.customerName?.includes(searchKeyWord1) ||
            x.customerNo?.includes(searchKeyWord1.toUpperCase());
          return searchZone && searchKeyword && searchShop;
        }),
      );
    };

    return (
      <Col span={11} style={{ borderColor: color.Grey, paddingLeft: "0px", paddingRight: "0px" }}>
        <Row
          style={{
            padding: "8px",
            background: "#6B7995",
            borderRadius: "4px",
          }}
        >
          <Col span={18} style={{ color: "white" }}>
            {leftStoreList.filter((x) => !x.isChecked).length} ร้าน
          </Col>
          {leftStoreList.some((x) => !x.isChecked) && (
            <Col
              span={6}
              style={{
                color: "white",
                cursor: isLeftAllCheckDis ? "not-allowed" : "pointer",
                display: "flex",
                justifyContent: "flex-end",
              }}
              onClick={() => {
                !isLeftAllCheckDis && handleSelectAllStore();
              }}
            >
              <PlusCircleOutlined />
              &nbsp;เลือกทั้งหมด
            </Col>
          )}
        </Row>
        {leftStoreList?.filter((x) => !x.isChecked).length > 0 ? (
          <Col
            style={{
              overflow: "scroll",
              minHeight: "300px",
              maxHeight: "300px",
              border: "solid",
              borderColor: "#F3F6F9",
              borderRadius: "4px",
            }}
          >
            {leftStoreList
              .filter((x) => !x.isChecked)
              ?.map((shop) => (
                <Row
                  key={shop.customerCompanyId}
                  justify={"space-between"}
                  style={{ alignItems: "center" }}
                >
                  <FlexCol style={{ padding: "4px 8px" }}>
                    <Text level={5}>{shop.customerName}</Text>
                    <Text level={6} color='Text3'>
                      {shop.customerNo} - {shop.zone}{" "}
                      {shop.customerGroupName && `• ${shop.customerGroupName}`}
                    </Text>
                  </FlexCol>
                  <FlexCol style={{ padding: "4px 18px" }}>
                    <PlusCircleOutlined
                      style={{
                        fontSize: "20px",
                        color: isLeftCheckDis ? color.Grey : "#0068F4",
                        cursor: isLeftCheckDis ? "not-allowed" : "pointer",
                      }}
                      onClick={() => {
                        !isLeftCheckDis && handleSelectStore(shop);
                      }}
                    />
                  </FlexCol>
                </Row>
              ))}
          </Col>
        ) : (
          <Row
            style={{
              overflow: "scroll",
              minHeight: "300px",
              border: "solid",
              borderColor: "#F3F6F9",
              borderRadius: "4px",
              padding: "30px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <img
              src={image.empty_shop}
              style={{
                width: 48,
                height: 48,
              }}
            />
            <br />
            <Text level={6} align={"center"} style={{ color: "#BABCBE" }}>
              ไม่มีร้านค้า
            </Text>
          </Row>
        )}
      </Col>
    );
  }; //ซ้าย

  const mergedUniqueStores = [...storeList, ...initialSelectedShop].reduce(
    (acc: StoreEntity[], curr: StoreEntity) => {
      const exists = acc.find(
        (item) => `${item.customerCompanyId}` === `${curr.customerCompanyId}`,
      );
      if (!exists) {
        acc.push(curr);
      }
      return acc;
    },
    [],
  );

  const storeRight = () => {
    const handleRemoveStore = (shop: StoreEntity) => {
      const d: StoreEntity[] = mergedUniqueStores.map((item) =>
        _.set(
          item,
          "isChecked",
          `${item.customerCompanyId}` === `${shop.customerCompanyId}` ? false : item.isChecked,
        ),
      );

      setIsLeftCheckDis(d.filter((x) => x.isChecked).length >= (limitSelected || 10000));
      setIsLeftAllCheckDis(limitSelected !== undefined ? true : false);
      setStoreSelected(d.filter((x) => x.isChecked));
      setRightStoreList(
        d.filter((x: any) => {
          const checked = x.isChecked;
          const searchZone = !searchZone2 || x.zone?.includes(searchZone2);
          const searchKeyword =
            !searchKeyWord2 ||
            x.customerName?.includes(searchKeyWord2) ||
            x.customerNo?.includes(searchKeyWord2.toUpperCase());
          return searchZone && searchKeyword && checked;
        }),
      );
      setLeftStoreList(
        storeList
          .map((el: any) => {
            const matching = d.find((i) => i.customerCompanyId === el.customerCompanyId);
            if (matching) {
              return { ...matching, isChecked: el.isChecked };
            }
            return {
              ...el,
              isChecked: el.isChecked,
            };
          })
          .filter((x: any) => {
            const checked = x.isChecked;
            const searchZone = !searchZone1 || x.zone?.includes(searchZone1);
            const searchShop = !searchShopGroup1 || x.customerGroupName === searchShopGroup1;
            const searchKeyword =
              !searchKeyWord1 ||
              x.customerName?.includes(searchKeyWord1) ||
              x.customerNo?.includes(searchKeyWord1.toUpperCase());
            return searchZone && searchKeyword && searchShop && !checked;
          }),
      );
    };
    const handleRemoveAllStore = () => {
      let d: StoreEntity[] = [];
      if (searchZone2 || searchKeyWord2 || searchShopGroup2) {
        const mapData = storeSelected.filter((x: any) => {
          const searchZone = !searchZone2 || x.zone?.includes(searchZone2);
          const searchShop = !searchShopGroup2 || x.customerGroupName === searchShopGroup2;
          const searchKeyword =
            !searchKeyWord2 ||
            x.customerName?.includes(searchKeyWord2) ||
            x.customerNo?.includes(searchKeyWord2.toUpperCase());
          return searchZone && searchKeyword && searchShop;
        });
        d = storeList.map((el: any) => {
          const matching = mapData.find((i) => i.customerCompanyId === el.customerCompanyId);
          if (matching) {
            return { ...matching, isChecked: false };
          }
          return {
            ...el,
            isChecked: el.isChecked,
          };
        });
      } else {
        d = storeList.map((p: any) => ({ ...p, isChecked: false }));
      }
      setIsLeftCheckDis(
        limitSelected !== undefined
          ? d.filter((x) => x.isChecked).length >= (limitSelected || 0)
          : false,
      );
      setStoreSelected(d.filter((x) => x.isChecked));
      setRightStoreList(
        d.filter((x: any) => {
          const checked = x.isChecked;
          const searchZone = !searchZone2 || x.zone?.includes(searchZone2);
          const searchShop = !searchShopGroup2 || x.customerGroupName === searchShopGroup2;
          const searchKeyword =
            !searchKeyWord2 ||
            x.customerName?.includes(searchKeyWord2) ||
            x.customerNo?.includes(searchKeyWord2.toUpperCase());
          return searchZone && searchKeyword && checked && searchShop;
        }),
      );
      setStoreList(d);
      setLeftStoreList(
        d.filter((x: any) => {
          const checked = x.isChecked;
          const searchZone = !searchZone1 || x.zone?.includes(searchZone1);
          const searchShop = !searchShopGroup1 || x.customerGroupName === searchShopGroup1;
          const searchKeyword =
            !searchKeyWord1 ||
            x.customerName?.includes(searchKeyWord1) ||
            x.customerNo?.includes(searchKeyWord1.toUpperCase());
          return searchZone && searchKeyword && searchShop && !checked;
        }),
      );
    };

    return (
      <Col span={11} style={{ borderColor: color.Grey, paddingLeft: "0px", paddingRight: "0px" }}>
        <Row
          style={{
            padding: "8px",
            background: "#464E5F",
            borderRadius: "4px",
          }}
        >
          <Col span={19} style={{ color: "white" }}>
            {rightStoreList.length !== 0 ? rightStoreList.length + " ร้าน" : "ไม่มีร้านค้าที่เลือก"}
          </Col>
          {rightStoreList.filter((x) => x.isChecked).length > 0 && (
            <Col
              span={5}
              style={{
                color: "white",
                cursor: "pointer",
                display: "flex",
                justifyContent: "flex-end",
              }}
              onClick={() => handleRemoveAllStore()}
            >
              <MinusCircleOutlined />
              &nbsp;ลบทั้งหมด
            </Col>
          )}
        </Row>
        {rightStoreList.length !== 0 ? (
          <Col
            style={{
              overflow: "scroll",
              minHeight: "300px",
              maxHeight: "300px",
              border: "solid",
              borderColor: "#F3F6F9",
              borderRadius: "4px",
            }}
          >
            {rightStoreList
              ?.filter((x) => x.isChecked)
              .map((shop) => (
                <Row
                  key={shop.customerCompanyId}
                  justify={"space-between"}
                  style={{ alignItems: "center" }}
                >
                  <FlexCol style={{ padding: "4px 8px" }}>
                    <Text level={5}>{shop.customerName}</Text>
                    <Text level={6} color='Text3'>
                      {shop.customerNo} - {shop.zone}
                    </Text>
                  </FlexCol>
                  <FlexCol style={{ padding: "4px 18px" }}>
                    <MinusCircleOutlined
                      style={{ fontSize: "20px", color: color.error, cursor: "pointer" }}
                      onClick={() => handleRemoveStore(shop)}
                    />
                  </FlexCol>
                </Row>
              ))}
          </Col>
        ) : (
          <Row
            style={{
              overflow: "scroll",
              minHeight: "300px",
              border: "solid",
              borderColor: "#F3F6F9",
              borderRadius: "4px",
              padding: "30px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <img
              src={image.empty_shop}
              style={{
                width: 48,
                height: 48,
              }}
            />
            <br />
            <Text level={6} align={"center"} style={{ color: "#BABCBE" }}>
              {storeSelected.length === 0 ? "โปรดเลือกร้านค้า" : "ไม่มีร้านค้า"}
            </Text>
          </Row>
        )}
      </Col>
    );
  }; //ขวา

  return (
    <Modal
      open={showModalShop}
      centered={true}
      onCancel={() => {
        onClose();
        setRightStoreList([]);
        setStoreSelected([]);
        setInitialSelectedShop([]);
      }}
      width={1200}
      title={
        replaceTitle ? (
          replaceTitle
        ) : (
          <>
            <Text style={{ fontSize: "20px" }} fontWeight={700}>
              เพิ่มร้านค้า
            </Text>
            {((limitSelected || 0) && storeList?.length) > 0 ? (
              <span style={{ fontSize: "15px", color: "#BABCBE" }}>
                {" "}
                เลือกคู่ค้าได้มากสุด {limitSelected} ร้านค้า
              </span>
            ) : (
              <span style={{ fontSize: "15px", color: "#BABCBE" }}>
                {" "}
                สามารถเลือกได้มากกว่า 1 ร้านค้า
              </span>
            )}
          </>
        )
      }
      footer={false}
    >
      <Form layout='vertical'>
        <Row gutter={24} justify={"space-between"}>
          <Col span={11} style={{ padding: "10px", background: "#1B4586", borderRadius: "5px" }}>
            <Text style={{ color: "white", fontSize: "15px" }} fontWeight={600}>
              เลือกร้านค้า
            </Text>
            <Divider style={{ backgroundColor: "white", margin: "10px 0" }} />
            <Row gutter={8}>
              <Col span={8}>
                <Text style={{ color: "white" }}>รายเขต</Text>
                <Select
                  style={{ width: "100%" }}
                  data={[
                    { label: "ทั้งหมด", key: "" },
                    ...(zoneList || []).map((z) => ({ label: z.zoneName, key: z.zoneName })),
                  ]}
                  onChange={(e) => handleSearchZone(e, 1)}
                  allowClear
                  value={searchZone1}
                />
              </Col>
              <Col span={8}>
                <Text style={{ color: "white" }}>กลุ่มลูกค้า</Text>
                <Select
                  style={{ width: "100%" }}
                  data={[
                    { label: "ทั้งหมด", key: "" },
                    ...(shopGroup.data || []).map((z) => ({
                      label: z.customerGroupName,
                      key: z.customerGroupName,
                    })),
                  ]}
                  onChange={(e) => handleSearchShopGroup(e, 1)}
                  allowClear
                  value={searchShopGroup1}
                />
              </Col>
              <Col span={8}>
                <Text style={{ color: "white" }}>ค้นหาร้านค้า</Text>
                <Input
                  suffix={<SearchOutlined color={color.Grey} />}
                  placeholder={"ระบุชื่อหรือรหัสร้านค้า"}
                  allowClear
                  onChange={(e) => handleSearchKeyword(e, 1)}
                  value={searchKeyWord1}
                />
              </Col>
            </Row>
          </Col>
          <Col span={11} style={{ padding: "10px", background: "#1B4586", borderRadius: "5px" }}>
            <Row gutter={8} justify={"space-between"}>
              <Col span={15}>
                <Text style={{ color: "white", fontSize: "15px" }} fontWeight={600}>
                  ร้านค้าที่เลือก
                </Text>
              </Col>
              {storeSelected.length != 0 && (
                <Col span={9}>
                  <Text style={{ color: "white", fontSize: "15px" }}>
                    เลือกแล้ว {storeSelected.length} ร้านค้า
                  </Text>
                </Col>
              )}
            </Row>
            <Divider style={{ backgroundColor: "white", margin: "10px 0" }} />
            <Row gutter={8}>
              <Col span={8}>
                <Text style={{ color: "white" }}>รายเขต</Text>
                <Select
                  style={{ width: "100%" }}
                  data={[
                    { label: "ทั้งหมด", key: "" },
                    ...(zoneList || []).map((z) => ({ label: z.zoneName, key: z.zoneName })),
                  ]}
                  onChange={(e) => handleSearchZone(e, 2)}
                  value={searchZone2}
                  allowClear
                />
              </Col>
              <Col span={8}>
                <Text style={{ color: "white" }}>กลุ่มลูกค้า</Text>
                <Select
                  style={{ width: "100%" }}
                  data={[
                    { label: "ทั้งหมด", key: "" },
                    ...(shopGroup.data || []).map((z) => ({
                      label: z.customerGroupName,
                      key: z.customerGroupName,
                    })),
                  ]}
                  onChange={(e) => handleSearchShopGroup(e, 2)}
                  allowClear
                  value={searchShopGroup2}
                />
              </Col>
              <Col span={8}>
                <Text style={{ color: "white" }}>ค้นหาร้านค้า</Text>
                <Input
                  suffix={<SearchOutlined color={color.Grey} />}
                  placeholder={"ระบุชื่อหรือรหัสร้านค้า"}
                  allowClear
                  onChange={(e) => handleSearchKeyword(e, 2)}
                  value={searchKeyWord2}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
      <Row gutter={24} justify={"space-between"} className='pt-2'>
        {storeLeft()}
        <Col span={1}>
          <SwapOutlined style={{ fontSize: "20px", marginTop: "150px", color: "#6B7995" }} />
        </Col>
        {storeRight()}
      </Row>
      <Divider />
      <Row justify='end'>
        <Button
          disabled={storeSelected?.length === 0}
          typeButton={storeSelected?.length === 0 ? "disabled" : "primary"}
          title={replaceSaveButtonTitle || "บันทึก"}
          style={{ width: 136 }}
          onClick={() => {
            callBackShop(storeSelected);
            setRightStoreList([]);
            setStoreSelected([]);
            setInitialSelectedShop([]);
          }}
        />
      </Row>
    </Modal>
  );
};
